import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CollectionSummaryDTO } from 'src/app/core/models/collectionSummaryDTO.model';
import { UserType } from 'src/app/core/models/userType.models';
import { CollectionService } from 'src/app/core/services/collection.service'; // ✅ Import the service
import { CollectionTransferService } from 'src/app/core/services/collectionTransfer.service';
import { LoginService } from 'src/app/core/services/login.service';
import { exportElementToPDF } from 'src/app/core/utils/pdf-utils';

import html2pdf from 'html2pdf.js';

declare var bootstrap: any;

@Component({
  selector: 'app-collection-summary-table',
  templateUrl: './collection-summary.component.html',
  styleUrls: ['./collection-summary.component.scss']
})

export class CollectionSummaryComponent implements OnInit {
  summaries: CollectionSummaryDTO[] = [];
  allSummaries: CollectionSummaryDTO[] = []; // Full unfiltered list
  availableMonths: string[] = [];
  selectedMonth: string = '';
  salesReps: string[] = [];                  // Unique list of sales reps
  selectedSalesRep: string = '';            // Current filter selection
  searchTerm: string = '';
  locationSuggestions: string[] = [];
  private searchTexts: string[] = [];
  private searchDebounce: any;
  pageSize = 100;
  pageNumber = 0;
  hasMore = true;
  isLoadingPage = false;

  expandedIndex: number | null = null;
  isRootUser: boolean = false;
  @ViewChild('collectionTableWrapper') collectionTableWrapper?: ElementRef<HTMLElement>;
  @ViewChild('editModal') editModalRef!: ElementRef;


  constructor(private collectionService: CollectionService, private collectionTransferService: CollectionTransferService,
             private loginService: LoginService
  ) {} // ✅ Inject service
  
  
ngOnInit(): void {
  this.isRootUser = this.loginService.userType === UserType.ROOT;

  this.loadSummaries();
}

private loadSummaries(forceRefresh: boolean = false): void {
  this.pageNumber = 0;
  this.hasMore = true;
  this.allSummaries = [];
  this.summaries = [];
  this.searchTexts = [];
  this.loadNextPage(forceRefresh);
}






  toggleExpand(index: number): void {
    if (this.expandedIndex !== index) {
      const target = this.summaries[index];
      if (target) this.sortGamesOnce(target);
    }
    const shouldOpen = this.expandedIndex !== index;
    this.expandedIndex = shouldOpen ? index : null;

    if (shouldOpen) {
      setTimeout(() => {
        this.collectionTableWrapper?.nativeElement.scrollTo({ left: 0, behavior: 'smooth' });
      });
    }
  }

  private sortGamesOnce(summary: CollectionSummaryDTO): void {
    const markerKey = '_gamesSorted';
    const asAny = summary as any;
    if (asAny[markerKey]) return;
    summary.gameSummaries = [...summary.gameSummaries].sort((a, b) => (b.cashInDelta || 0) - (a.cashInDelta || 0));
    asAny[markerKey] = true;
  }

  getTotalCashIn(games: { cashInDelta: number }[]): number {
  return games.reduce((sum, g) => sum + (g.cashInDelta || 0), 0);
}

getTotalCashOut(games: { cashOutDelta: number }[]): number {
  return games.reduce((sum, g) => sum + (g.cashOutDelta || 0), 0);
}

getTotalGross(games: { gross: number }[]): number {
  return games.reduce((sum, g) => sum + (g.gross || 0), 0);
}

getDaysBetween(previousDate: string, currentDate: string): number {
  const prev = new Date(previousDate);
  const curr = new Date(currentDate);

  const diffTime = curr.getTime() - prev.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // convert ms to days

  return diffDays;
}

getOverallTotalCashIn(): number {
  return this.summaries.reduce((sum, s) => sum + this.getTotalCashIn(s.gameSummaries), 0);
}

getOverallTotalCashOut(): number {
  return this.summaries.reduce((sum, s) => sum + this.getTotalCashOut(s.gameSummaries), 0);
}

getOverallTotalGross(): number {
  return this.summaries.reduce((sum, s) => sum + this.getTotalGross(s.gameSummaries), 0);
}

getOverallTotalNet(): number {
  return this.summaries.reduce((sum, s) => sum + this.getNet(s), 0);}


getNet(summary: CollectionSummaryDTO): number {
  return (summary.totalGross ?? 0) * (summary.splitPercentage ?? 0);
}

getTotalBoards(): number {
  return this.summaries.reduce((sum, s) => sum + (s.numberOfBoards || 0), 0);
}
      saveAmountReceived(summary: CollectionSummaryDTO): void {
        this.collectionService.updateAmountReceived(summary).subscribe({
          next: () => {
            console.log('Amount received updated successfully');
          },
          error: (err) => {
            console.error('Failed to update amount received', err);
          }
        });
      }
    getOverallTotalReceived(): number {
      return this.summaries.reduce((sum, s) => sum + (s.amountReceived || 0), 0);
    }

    deleteCollection(summary: CollectionSummaryDTO): void {
    const confirmed = confirm(`Are you sure you want to delete the collection for ${summary.locationName}?`);
    if (!confirmed) return;
          this.collectionService.deleteCollection(summary.id).subscribe({
            next: () => {
              this.summaries = this.summaries.filter(s => s.id !== summary.id);
              alert('Collection deleted successfully.');
            },
            error: (err) => {
              console.error(err);
              alert('Failed to delete collection.');
            }
          });
        }
    selectedSummary: CollectionSummaryDTO | null = null;

openEditModal(summary: CollectionSummaryDTO): void {
  this.selectedSummary = { ...summary };

  setTimeout(() => {
    const modal = new bootstrap.Modal(this.editModalRef.nativeElement);
    modal.show();
  }, 0);
}




      updateCollectorShare(): void {
        if (this.selectedSummary?.totalGross != null && this.selectedSummary?.splitPercentage != null) {
          this.selectedSummary.collectorShare = this.selectedSummary.totalGross * this.selectedSummary.splitPercentage;
        }
      }
saveEdit(): void {
  if (!this.selectedSummary) return;

  const payload = {
    splitPercentage: this.selectedSummary.splitPercentage,
    amountReceived: this.selectedSummary.amountReceived,
    collectorShare: this.selectedSummary.collectorShare
  };

  this.collectionService.updateFields(this.selectedSummary.id!, payload).subscribe({
    next: () => {
      const index = this.summaries.findIndex(s => s.id === this.selectedSummary!.id);
      if (index !== -1) this.summaries[index] = { ...this.selectedSummary! };
      this.selectedSummary = null;
      const modal = bootstrap.Modal.getInstance(document.getElementById('editCollectionModal')!);
      modal?.hide();
      alert('Collection updated successfully');
    },
    error: (err) => {
      console.error('Update failed:', err);
      alert('Failed to update collection.');
    }
  });
}
filterBySalesRep(): void {
  this.applyCombinedFilters();
}

getTotalCarryoverGross(): number {
  return this.summaries.reduce((sum, s) => sum + (s.carryoverGross || 0), 0);
}

getTotalCarriedCollectorShare(): number {
  return this.summaries.reduce((sum, s) => sum + (s.carriedCollectorShare || 0), 0);
}

getCurrentMonthTag(): string {
  const now = new Date();
  return `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}`;
}

filterByMonth(): void {
  this.applyCombinedFilters();
}

onSearchChange(): void {
  if (this.searchDebounce) {
    clearTimeout(this.searchDebounce);
  }
  this.searchDebounce = setTimeout(() => this.applyCombinedFilters(), 120);
}

applyCombinedFilters(): void {
  const term = this.searchTerm.trim().toLowerCase();
  this.summaries = this.allSummaries.filter((summary, idx) => {
    const matchesMonth = term ? true : (this.selectedMonth ? summary.collectionMonth === this.selectedMonth : true);
    const matchesRep = this.selectedSalesRep ? summary.salesRepName === this.selectedSalesRep : true;
    const matchesSearch = term ? this.searchTexts[idx]?.includes(term) : true;
    return matchesMonth && matchesRep && matchesSearch;
  });
}

loadNextPage(forceRefresh: boolean = false): void {
  if (!this.hasMore || this.isLoadingPage) return;
  this.isLoadingPage = true;
  const targetPage = forceRefresh ? 0 : this.pageNumber;

  this.collectionService.getSummariesPage(targetPage, this.pageSize, undefined, this.selectedSalesRep || '').subscribe({
    next: (data) => {
      if (forceRefresh || targetPage === 0) {
        this.allSummaries = [];
        this.summaries = [];
        this.searchTexts = [];
      }

      const normalized = data.map(summary => ({
        ...summary,
        gameSummaries: summary.gameSummaries, // defer sorting until expand for speed
        carryoverGross: summary.carryoverGross ?? 0,
        newGross: summary.newGross ?? null
      }));

      this.allSummaries = [...this.allSummaries, ...normalized];
      this.searchTexts = this.allSummaries.map(s => this.buildSearchText(s));

      this.availableMonths = [...new Set(this.allSummaries.map(d => d.collectionMonth))].sort().reverse();
      this.salesReps = [...new Set(this.allSummaries.map(s => s.salesRepName).filter(Boolean))];
      this.locationSuggestions = this.buildLocationSuggestions();

      if (this.selectedMonth && !this.availableMonths.includes(this.selectedMonth)) {
        this.selectedMonth = this.availableMonths[0] || '';
      }
      if (!this.selectedMonth) {
        this.selectedMonth = this.getCurrentMonthTag();
      }

      this.filterByMonth();
      this.pageNumber = targetPage + 1;
      this.hasMore = data.length === this.pageSize;
    },
    error: (err) => {
      console.error('Failed to load summaries page', err);
      this.hasMore = false;
    },
    complete: () => {
      this.isLoadingPage = false;
    }
  });
}

downloadPdf(): void {
  if (!this.selectedMonth) return;

  this.collectionService.exportToPdf(this.selectedMonth, this.selectedSalesRep).subscribe(blob => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `collection-summary-${this.selectedMonth}.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);
  });
}

downloadExcel(): void {
  if (!this.selectedMonth) return;

  this.collectionService.exportToExcel(this.selectedMonth, this.selectedSalesRep).subscribe(blob => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `collection-summary-${this.selectedMonth}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
  });
}

exportPdf(summaryId: string): void {
  const summary = this.summaries.find(s => s.id === summaryId);
  if (!summary) return;

  const formatForFilename = (value: string | undefined | null) =>
    (value || '')
      .trim()
      .replace(/[^a-z0-9]+/gi, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();

  const formatDate = (dateStr: string) =>
    new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      .format(new Date(dateStr));

  const formatDateForFilename = (dateStr: string) => {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return formatForFilename(dateStr);
    return date.toISOString().split('T')[0];
  };

  const locationPart = formatForFilename(summary.locationName) || 'location';
  const datePart = formatDateForFilename(summary.currentDate || summary.previousDate);

  const gameRows = summary.gameSummaries.map(game => `
    <tr>
      <td>${game.gameName}</td>
      <td>${this.currency(game.cashInDelta)}</td>
      <td>${this.currency(game.cashOutDelta)}</td>
      <td>${this.currency(game.gross)}</td>
    </tr>
  `).join('');

  const htmlContent = `
    <div style="font-family: Arial, sans-serif; padding: 30px; max-width: 800px;">
      <h4 style="margin-bottom: 20px;">📊 Collection Summary</h4>
      <div style="border: 1px solid #ccc; border-radius: 6px; padding: 16px; margin-bottom: 20px; background-color: #f9f9f9;">
        <p><strong>Location:</strong> ${summary.locationName}</p>
        <p><strong>Previous Date:</strong> ${formatDate(summary.previousDate)}</p>
        <p><strong>Current Date:</strong> ${formatDate(summary.currentDate)}</p>
        <p><strong>Total Cash In:</strong> ${this.currency(summary.totalCashIn)}</p>
        <p><strong>Total Cash Out:</strong> ${this.currency(summary.totalCashOut)}</p>
        <p><strong>Gross:</strong> ${this.currency(summary.newGross ?? summary.totalGross)}</p>
        <p><strong>Split:</strong> ${summary.splitPercentage * 100}%</p>
        <p><strong>Collector Share:</strong> ${this.currency(summary.collectorShare)}</p>
      </div>

      <table style="width: 100%; border-collapse: collapse;">
        <thead style="background-color: #f2f2f2;">
          <tr>
            <th style="padding: 8px; border: 1px solid #ddd; text-align: left;">Game</th>
            <th style="padding: 8px; border: 1px solid #ddd; text-align: right;">Cash In</th>
            <th style="padding: 8px; border: 1px solid #ddd; text-align: right;">Cash Out</th>
            <th style="padding: 8px; border: 1px solid #ddd; text-align: right;">Gross</th>
          </tr>
        </thead>
        <tbody>
          ${gameRows}
          <tr style="font-weight: bold; background-color: #333; color: #fff;">
            <td style="padding: 8px; border: 1px solid #ddd;">Total</td>
            <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${this.currency(this.getTotalCashIn(summary.gameSummaries))}</td>
            <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${this.currency(this.getTotalCashOut(summary.gameSummaries))}</td>
            <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${this.currency(this.getTotalGross(summary.gameSummaries))}</td>
          </tr>
        </tbody>
      </table>
    </div>
  `;

  const options = {
    margin: 0.5,
    filename: `collection-summary-${locationPart}-${datePart}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
  };

  html2pdf().from(htmlContent).set(options).save();
}

currency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value || 0);
}

getAddressLine(summary: CollectionSummaryDTO): string {
  const address = summary.locationAddress as any;
  if (!address) return '';
  if (typeof address === 'string') return address;
  const parts = [
    address.streetAddress1,
    address.streetAddress2,
    address.city,
    address.state,
    address.zipCode,
    address.country
  ].filter(Boolean);
  return parts.join(', ');
}

private buildLocationSuggestions(): string[] {
  const suggestions = new Set<string>();
  this.allSummaries.forEach(summary => {
    if (summary.locationName) suggestions.add(summary.locationName);
    const addressLine = this.getAddressLine(summary);
    if (addressLine) suggestions.add(addressLine);
  });
  return Array.from(suggestions);
}

private buildSearchText(summary: CollectionSummaryDTO): string {
  const parts = [
    summary.locationName,
    this.getAddressLine(summary)
  ].filter(Boolean);
  return parts.join(' ').toLowerCase();
}


}

